import React, { useEffect, useState } from "react";
import { Grid, Icon, Typography } from './index';
import { PageHeading } from './mybswh';
import * as Tools from "../../helpers/Tools";
import './test_component.scss';

const TestComponent = (props) => {

    return (
        <Grid className="body-content bsw-test-components">
            <div className="row">
                <div className="col-12">
                    <PageHeading heading="Components" />
                    <div>
                        <Icon name="message-notification" size="small"/>
                        <Icon name="message-notification" />
                        <Icon name="message-notification" size="large" />
                        <Icon name="message-notification" size="xlarge" />
                    </div>
                    <div>
                        <Typography tag="div">Disabled</Typography>
                        <Icon name="message-notification" disabled />
                    </div>
                </div>
            </div>
        </Grid>
    );

}

export default TestComponent;
